import React from "react";
import VaptStatusBadge from "./VaptStatusBadge";

// Shows the original scan result plus a list of retest attempts.
// Original result is never overwritten — each retest is appended.
const VaptRetestHistory = ({ finding }) => {
  if (!finding) return null;
  const retests = finding.retests || [];

  return (
    <div className="space-y-4">
      <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Original Scan Result</p>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-900">{finding.title}</p>
            <p className="text-xs text-gray-500">
              Detected via {finding.tool} on {new Date(finding.detectedAt).toLocaleDateString()}
            </p>
          </div>
          <VaptStatusBadge status={finding.validationStatus} size="sm" />
        </div>
      </div>

      <div>
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
          Retest Attempts ({retests.length})
        </p>
        {retests.length === 0 ? (
          <p className="text-sm text-gray-400">No retests recorded yet.</p>
        ) : (
          <div className="space-y-2">
            {retests.map((r) => (
              <div key={r.id} className="border border-gray-100 rounded-lg p-3 flex items-start justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-800">Attempt #{r.attempt}</p>
                  <p className="text-xs text-gray-500">
                    {new Date(r.date).toLocaleDateString()} {r.tester ? `• ${r.tester}` : ""}
                  </p>
                  {r.notes && <p className="text-xs text-gray-600 mt-1">{r.notes}</p>}
                </div>
                <VaptStatusBadge status={r.result} size="sm" />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VaptRetestHistory;
